module.exports = __webpack_public_path__ + "img/IMG_3119_L_WoodMatted_MockedUp.5c773fb0.jpg";